import { expVal } from '@atlassian/jira-feature-experiments';

export const jiraIssueTableHierarchyAnalyticRelayProvider = {
	get(): boolean {
		return expVal('jira_issue_table_hierarchy_analytic', 'isEnabled', false);
	},
};

export default jiraIssueTableHierarchyAnalyticRelayProvider;
